import { _firestore } from '../../firebase';
import localStorage from 'local-storage';
import ActionTypes from './constants';
import moment from 'moment-timezone';
import getFormattedMobileNumber from '../../helpers/getFormattedMobileNumber';
import {
  getCategoriesPromise,
  getMenuItemsPromise,
  getAllSpecialsPromise,
  getSoldOutMenuItemsPromise,
  getMenuItemSizesPromise,
  getMenuItemSubModifiersPromise,
  getItemSizesPromise,
  getPopularsPromise,
  getOrderSetupPromise,
  getMenuItemSchedules,
  getMenuItemSchedulesPromise,
} from './methods';
import { selectStoreConfig } from '../../containers/Layout/selectors';
import store from '../../store';

function updateMenuItems(menuItems, populars, menuItemSchedules) {
  if (menuItemSchedules?.length > 0) {
    const updatedMenuItems = menuItems?.filter(({ _id }) => {
      return !menuItemSchedules?.find(
        ({ menuItemId, isAvailableNow }) =>
          menuItemId === _id && !isAvailableNow
      );
    });
    const updatedPopulars = populars?.filter(({ _id }) => {
      return !menuItemSchedules?.find(
        ({ menuItemId, isAvailableNow }) =>
          menuItemId === _id && !isAvailableNow
      );
    });
    return { menuItems: updatedMenuItems, populars: updatedPopulars };
  }
  return { menuItems, populars };
}

export function init(storeId, restaurantId) {
  return async function (dispatch) {
    let [
      categories,
      menuItems,
      menuItemSchedules,
      soldOutMenuItems,
      allSpecials,
      populars,
      itemSizes,
      menuItemSizes,
      menuItemSubModifiers,
      orderSetup,
    ] = await Promise.all([
      getCategoriesPromise(storeId),
      getMenuItemsPromise(storeId),
      getMenuItemSchedulesPromise(storeId),
      getSoldOutMenuItemsPromise(storeId),
      getAllSpecialsPromise(storeId),
      getPopularsPromise(storeId),
      getItemSizesPromise(restaurantId),
      getMenuItemSizesPromise(storeId),
      getMenuItemSubModifiersPromise(storeId),
      getOrderSetupPromise(storeId),
    ]);

    const { isPopularDisabled = false } = orderSetup || {};

    if (isPopularDisabled) {
      populars = [];
    }

    const { menuItems: updatedMenuItems, populars: updatedPopulars } =
      updateMenuItems(menuItems, populars, menuItemSchedules);

    dispatch({
      type: ActionTypes.Initialize,
      categories,
      allPopulars: populars,
      populars: updatedPopulars,
      allSpecials,
      allMenuItems: menuItems,
      menuItems: updatedMenuItems,
      menuItemSchedules,
      soldOutMenuItems,
      itemSizes,
      menuItemSizes,
      menuItemSubModifiers,
      orderSetup,
    });
    dispatch(getMenuItemSchedules(storeId));
  };
}

export function updateMenuItemSchedules(menuItemSchedules) {
  return async function (dispatch) {
    const { menuItems, populars } = updateMenuItems(
      store?.getState()?.homeReducer?.allMenuItems,
      store?.getState()?.homeReducer?.allPopulars,
      menuItemSchedules
    );

    dispatch({
      type: ActionTypes.UpdateMenuItemSchedules,
      menuItemSchedules,
      menuItems,
      populars,
    });
  };
}

export function getUserData() {
  const {
    _id = '',
    mobileNumber = '',
    storeId = '',
    restaurantId = '',
    firstName = '',
    lastName = '',
  } = store.getState()?.homeReducer?.userDetails || {};
  const { Aa = '' } = store.getState()?.homeReducer?.currentUser || {};

  const data = {
    userId: _id,
    mobileNumber,
    storeId,
    restaurantId,
    firstName,
    lastName,
    token: Aa,
  };

  return data;
}

window.getUserData = () => {
  const userData = getUserData();
  const data = {
    type: 'userdata',
    userdata: {
      ...userData,
    },
  };
  window.ReactNativeWebView?.postMessage?.(JSON.stringify(data));
  return userData;
};

export const postUserDataToRNWebView = (type = 'login') => {
  const userData = getUserData();
  const data = {
    type,
    userdata: {
      ...userData,
    },
  };
  window.ReactNativeWebView?.postMessage?.(JSON.stringify(data));
  return data;
};

export function getCurrentUseDetails(
  user,
  newUser,
  storeId,
  restaurantId,
  isLogin
) {
  return (dispatch) => {
    dispatch(isFetchingCustomers(true));
    _firestore
      .collection('Users')
      .where('restaurantId', '==', restaurantId)
      .where('uid', '==', user.uid)
      .get()
      .then((querySnapshot) => {
        var dataArray = [];
        querySnapshot.forEach((doc) => {
          dataArray.push({ ...doc.data(), _id: doc.id });
        });
        if (dataArray.length <= 0 && newUser) {
          let reffUser = _firestore.collection('Users').doc();
          newUser.uid = user.uid;
          newUser._id = reffUser.id;
          newUser.isNewCustomer = true;
          reffUser.set(newUser).then((_doc) => {
            _firestore
              .collection('PathwayToOffers')
              .where('restaurantId', '==', restaurantId)
              .where('userId', '==', reffUser.id)
              .where('isUsed', '==', false)
              .get()
              .then((querySnapshotI) => {
                var dataArrayI = [];
                querySnapshotI.forEach((docI) => {
                  dataArrayI.push({ _id: docI.id, ...docI.data() });
                });
                console.log('getCurrentUseDetails');
                dispatch(
                  allCustomersFetched(user, newUser, dataArrayI, isLogin)
                );
                dispatch(isFetchingCustomers(false));
              })
              .catch((err) => {
                console.error(err);
                dispatch(isFetchingCustomers(false));
              });
          });
        } else {
          if (
            dataArray &&
            dataArray.length > 0 &&
            dataArray[0] &&
            dataArray[0]._id
          ) {
            _firestore
              .collection('PathwayToOffers')
              .where('restaurantId', '==', restaurantId)
              .where('userId', '==', dataArray[0]._id)
              .where('isUsed', '==', false)
              .onSnapshot((querySnapshotI) => {
                var dataArrayI = [];
                querySnapshotI.forEach((docI) => {
                  dataArrayI.push({ _id: docI.id, ...docI.data() });
                });
                dispatch(
                  allCustomersFetched(user, dataArray[0], dataArrayI, isLogin)
                );
                dispatch(isFetchingCustomers(false));
              });
          } else {
            dispatch(isFetchingCustomers(false));
          }
        }
      });
  };
}

export function setState(newState) {
  return {
    type: `@home/setState`,
    payload: newState,
  };
}

export function updateCurrentOrderObj(id, obj) {
  return (dispatch, getState) => {
    const storeConfig = selectStoreConfig(getState());
    try {
      if (window.localStorage) {
        if (localStorage.get('currentOrder')) {
          obj.date = moment()
            .tz(storeConfig.timeZone)
            .format('YYYY-MM-DD HH:mm');
          localStorage.set('currentOrder', obj);
          dispatch(orderUpdated(obj));
        } else {
          dispatch(orderUpdated(obj));
        }
      } else {
        dispatch(orderUpdated(obj));
      }
    } catch (err) {
      dispatch(orderUpdated(obj));
    }
  };
}

export function fetchOrder(orderId) {
  return (dispatch) => {
    let orderRef = _firestore.collection('Orders').doc(orderId);
    orderRef.onSnapshot((querySnapshot) => {
      let objj = querySnapshot.data();
      if (objj) {
        objj._id = querySnapshot.id;
        try {
          if (window.localStorage) {
            if (localStorage.get('currentOrder')) {
              localStorage.set('currentOrder', objj);
              dispatch(orderUpdated(objj));
            } else {
              dispatch(orderUpdated(objj));
            }
          } else {
            dispatch(orderUpdated(objj));
          }
        } catch (err) {
          dispatch(orderUpdated(objj));
        }
      }
    });
  };
}

export function addReservation(reservation, currentUser) {
  return (dispatch, getState) => {
    const storeConfig = selectStoreConfig(getState());
    reservation.userId = currentUser._id;
    reservation.storeId = storeConfig.storeId;
    reservation.restaurantId = storeConfig.restaurantId;
    reservation.firstName = currentUser.firstName;
    reservation.lastName = currentUser.lastName;
    reservation.userName = currentUser.firstName + ' ' + currentUser.lastName;
    reservation.mobileNumber = getFormattedMobileNumber(
      currentUser.mobileNumber
    );
    reservation.date = moment()
      .tz(storeConfig.timeZone)
      .format('YYYY-MM-DD HH:mm');
    reservation.isProcessedForCommision = false;
    let now = new Date();
    reservation.dateTimestamp = now.getTime();
    _firestore
      .collection('Reservations')
      .add(reservation)
      .then((doc) => {
        let ref = _firestore.collection('Reservations').doc(doc.id);
        ref.get().then((querySnapshot) => {
          let data = querySnapshot.data();
          try {
            dispatch(reservationFetched(data));
          } catch (err) {}
        });
      });
  };
}

export function takeSignOutAction() {
  return (dispatch) => {
    dispatch(signOutAction());
  };
}

export function filterView(filter) {
  return {
    type: ActionTypes.FilterView,
    ...filter,
  };
}

export function orderUpdated(currentOrder) {
  return {
    type: ActionTypes.LoadCurrentOrder,
    currentOrder,
  };
}

function reservationFetched(currentReservations) {
  return {
    type: ActionTypes.FetchedReservations,
    currentReservations,
  };
}

function isFetchingCustomers(isFetching) {
  return {
    type: ActionTypes.FetchUserByUidLoading,
    isFetching,
  };
}

function allCustomersFetched(
  currentUser,
  userDetails,
  pathwayToOffers,
  isLogin
) {
  if (isLogin) {
    setTimeout(() => {
      postUserDataToRNWebView();
    }, 50);
  }
  return {
    type: ActionTypes.FetchUserByUid,
    userDetails,
    currentUser,
    pathwayToOffers,
  };
}

function signOutAction() {
  console.log('signOutAction');
  postUserDataToRNWebView('logout');
  return {
    type: ActionTypes.FetchUserByUid,
    userDetails: undefined,
    currentUser: undefined,
    pathwayToOffers: [],
  };
}

export function toggleMobileCart() {
  return { type: ActionTypes.ToggleMobileCart };
}

export function setLayoutFlow(value) {
  return { type: ActionTypes.SetLayoutFlow, value };
}

export function setNotes(notes) {
  return { type: ActionTypes.SetNotes, notes };
}

export function setBookingNotes(bookingNotes) {
  return { type: ActionTypes.SetBookingNotes, bookingNotes };
}

export function setSlideIndex(value) {
  return {
    type: ActionTypes.SetSlideIndex,
    value,
  };
}

export function setMenuLoading(value) {
  return { type: ActionTypes.SetMenuLoading, value };
}
